import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import Settings from "../component/features/settings/Settings";

export class SettingsRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/settings"} component={Settings} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};